// extracted by mini-css-extract-plugin
module.exports = {"menuAcciones":"ListaFacturas_menuAcciones__2xC30","externalLinkImg":"ListaFacturas_externalLinkImg__3SDYT"};